export const parseNumber = (value: string): string => value.replace(/ |\(|\)|_/g, '');

export const isValidNumber = (value: string): boolean => parseNumber(value).length === 12;
